var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Track } from "./objects";
import { fetchUrl } from "./requests";
/**
 * A handler to fetch, manipulate and delete tracks.
 */
var TrackHandler = /** @class */ (function () {
    /**
     * Creates a `TrackHandler` object to manage track processing.
     *
     * @param setTracks A callback method to set the tracks' state in the UI
     * @param requestURL The URl of the backend server to start requests from
     * @param underground If requests should be sent to the underground database
     * @param listCount The amount of tracks to fetch in each listing
     */
    function TrackHandler(setTracks, requestURL, underground, listCount) {
        /**
         * If tracks are actively being searched. This will disable websocket song adding.
         */
        this.searching = false;
        this.setTracks = setTracks;
        this.requestURL = requestURL;
        this.underground = underground;
        this.listCount = listCount;
        this.baseListUrl = "".concat(this.requestURL, "/api/tracks/list");
        this.nextURL = "".concat(this.baseListUrl, "?count=").concat(listCount, "&underground=").concat(this.underground);
        this.originalURL = this.nextURL;
    }
    /**
     * Resets the current page.
     */
    TrackHandler.prototype.reset = function () {
        this.nextURL = this.originalURL;
    };
    /**
     * Loads more tracks (Setting new ones via `setTracks`). This may be used for initial loading as well.
     */
    TrackHandler.prototype.loadMoreTracks = function () {
        return this.loadTracksFromUrl(this.nextURL);
    };
    /**
     * Loads tracks from the given URL, setting them with `setTracks`.
     *
     * @param url The URL to request tracks from
     * @param overrideList If previous tracks should be ignored when invoking `setTracks` (`true` sets all tracks to
     *                     the fetched collection)
     * @param searching If this is a searching request (ignores incoming websocket tracks if true)
     */
    TrackHandler.prototype.loadTracksFromUrl = function (url, overrideList, searching) {
        var _this = this;
        if (overrideList === void 0) { overrideList = false; }
        if (searching === void 0) { searching = false; }
        this.searching = searching;
        return fetchUrl(url)
            .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, json, tracks;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(res.status != 200)) return [3 /*break*/, 2];
                        _b = (_a = console).error;
                        _d = (_c = "[tracks/list] Erroneous status of ".concat(res.status, ": ")).concat;
                        return [4 /*yield*/, res.json()];
                    case 1:
                        _b.apply(_a, [_d.apply(_c, [_e.sent()])]);
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, res.json()];
                    case 3:
                        json = _e.sent();
                        this.nextURL = json['_links']['next'];
                        tracks = json['tracks'].map(function (track) { return Track.fromJSON(track); });
                        if (overrideList) {
                            this.setTracks(tracks);
                        }
                        else {
                            this.setTracks(function (old) { return __spreadArray(__spreadArray([], old, true), tracks, true); });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Deletes a track from the system, updating the UI with `setTracks`.
     *
     * @param track The track to delete
     */
    TrackHandler.prototype.deleteTrack = function (track) {
        var _this = this;
        return fetchUrl("".concat(this.requestURL, "/api/tracks/delete"), {
            id: track.id.toString(),
            underground: "".concat(this.underground)
        }, {
            method: 'DELETE'
        }).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(res.status != 200)) return [3 /*break*/, 2];
                        _b = (_a = console).error;
                        _d = (_c = "[tracks/remove] Erroneous status of ".concat(res.status, ": ")).concat;
                        return [4 /*yield*/, res.json()];
                    case 1:
                        _b.apply(_a, [_d.apply(_c, [_e.sent()])]);
                        return [2 /*return*/];
                    case 2:
                        this.setTracks(function (old) { return old.filter(function (oldTrack) { return oldTrack.id != track.id; }); });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Adds a track to the system, updating the UI with `setTracks`.
     *
     * @param title The title of the track
     * @param artist The artist name of the track
     * @param group The group of the track
     * @param date The date the track was played
     * @param event If this is adding an event
     */
    TrackHandler.prototype.submitAdd = function (title, artist, group, date, event) {
        var _this = this;
        return fetchUrl("".concat(this.requestURL, "/api/tracks/add"), { underground: "".concat(this.underground) }, {
            method: 'POST',
            body: JSON.stringify({
                'title': event ? '' : title,
                'artist': artist,
                'group': event ? 'Event' : group,
                'time': date.getTime()
            })
        }).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!(res.status != 200)) return [3 /*break*/, 2];
                        _b = (_a = console).error;
                        _d = (_c = "[tracks/add] Erroneous status of ".concat(res.status, ": ")).concat;
                        return [4 /*yield*/, res.json()];
                    case 1:
                        _b.apply(_a, [_d.apply(_c, [_h.sent()])]);
                        return [2 /*return*/];
                    case 2:
                        _e = this.manualAddTrack;
                        _g = (_f = Track).fromJSON;
                        return [4 /*yield*/, res.json()];
                    case 3:
                        _e.apply(this, [_g.apply(_f, [_h.sent()])]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Searches for tracks with the given parameters. All are optional, if no search parameters can be used, this
     * defaults to an initial track listing.
     *
     * To filter between dates, both `startDate` and `endDate` must be defined.
     *
     * @param artist The artist to search
     * @param title The title to search
     * @param startDate The inclusive start date to filter tracks by
     * @param endDate The inclusive end date to filter tracks by
     */
    TrackHandler.prototype.searchTracks = function (artist, title, startDate, endDate) {
        var urlQuery = new URLSearchParams({ count: "".concat(this.listCount), underground: "".concat(this.underground) });
        var searching = false;
        artist !== null && artist !== void 0 ? artist : (artist = '');
        if (artist != '') {
            searching = true;
            urlQuery.append('artist', artist);
        }
        title !== null && title !== void 0 ? title : (title = '');
        if (title != '') {
            searching = true;
            urlQuery.append('song', title);
        }
        if (startDate != undefined && endDate != undefined) {
            searching = true;
            urlQuery.append('start', startDate.getTime().toString());
            urlQuery.append('end', endDate.getTime().toString());
        }
        return this.loadTracksFromUrl("".concat(this.baseListUrl, "?").concat(urlQuery), true, searching);
    };
    /**
     * Updates the `Track` with the given information, updating the UI with `setTracks`.
     *
     * @param id The original ID of the track
     * @param track The `Track` object
     * @param title The new title of the track
     * @param artist The new artist of the track
     * @param group The new group of the track
     * @param date The new date of the track
     */
    TrackHandler.prototype.updateTrack = function (id, track, title, artist, group, date) {
        var _this = this;
        return fetchUrl("".concat(this.requestURL, "/api/tracks/update"), { underground: "".concat(this.underground) }, {
            method: 'PATCH',
            body: JSON.stringify(__assign(__assign({ 'id': id, 'title': title }, (!track.isEvent() && {
                'artist': artist,
                'group': group
            })), { 'time': date.getTime() }))
        }).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(res.status != 200)) return [3 /*break*/, 2];
                        _b = (_a = console).error;
                        _d = (_c = "[tracks/update] Erroneous status of ".concat(res.status, ": ")).concat;
                        return [4 /*yield*/, res.json()];
                    case 1:
                        _b.apply(_a, [_d.apply(_c, [_e.sent()])]);
                        return [2 /*return*/];
                    case 2:
                        this.setTracks(function (old) {
                            var editedTrack = old.find(function (track) { return track.id == id; });
                            if (editedTrack == undefined) {
                                console.error('Edited track not found!');
                                return old;
                            }
                            editedTrack.title = title;
                            editedTrack.artist = artist;
                            editedTrack.group = group;
                            editedTrack.time = date;
                            return old;
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Allows the UI caller to add a track manually. This is used for admin UI.
     * This invokes `setTracks`, ensuring the track is not a duplicate.
     *
     * @param track The track being added
     */
    TrackHandler.prototype.manualAddTrack = function (track) {
        // Don't add if a duplicate
        this.setTracks(function (old) {
            if (old.findIndex(function (t) { return t.id == track.id; }) === -1) {
                return __spreadArray([track], old, true);
            }
            else {
                return old;
            }
        });
    };
    return TrackHandler;
}());
export { TrackHandler };
